/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken, getParams } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProSettings.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import CompanySignUpForm from './partials/CompanySignUpForm';
import { STRIPE_CLIENT_ID, STRIPE_REDIRECT_URI } from '../config';
import {
  register,
  fetchUser,
  listCompanies,
  connectStripe,
} from '../actions';


class ProSettings extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  componentDidMount() {
    this.props.listCompanies({ mine: 1 });
    let params = getParams();
    console.log('debug stripe got params', params);
    if (params.state == 'stripe') {
      this.props.connectStripe(params)
        .then(resp => {
          console.log('connect stripe resp:', resp);
          if (resp.error) {
            alert('Error while trying to connect to Stripe');
          }
          navTo('/pro/settings');
          this.props.listCompanies({ mine: 1 }, { background: true });
        });
    }
  }

  renderStripe() {
    let companies = this.props.companies;
    if (!companies) return;
    let company = companies.items[0];
    if (!company) return;

    let node;
    if (company.stripe) {
      node = <div><FontAwesome name="check-circle" /> Stripe is connected</div>;
    } else {
      // let stripeUrl = 'https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=' + STRIPE_CLIENT_ID + '&state=stripe&redirect_uri=' + STRIPE_REDIRECT_URI;
      let stripeUrl = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + STRIPE_CLIENT_ID + '&scope=read_write&state=stripe&redirect_uri=' + STRIPE_REDIRECT_URI;
      node = <div><a href={stripeUrl}><Button>Connect Stripe</Button></a></div>;
    }

    return (
      <div className="stripe">
        {node}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProSettings" padded pro>
        <div className="pro-header">Settings</div>
        {this.renderStripe()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    fetchUser,
    listCompanies,
    connectStripe,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProSettings);



/** WEBPACK FOOTER **
 ** ./src/components/ProSettings.js
 **/